import React, { useEffect, useState } from 'react'
import { uid } from '@zera-admin/utils'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Button, { ButtonGroup, LinkButton } from '@zera-admin/button'
import Page, { PageHeader, Container } from '@zera-admin/page'

import { ValidationError } from 'app/shared/types'
import { useFlagcardContext } from 'app/contexts/flagcard'
import MainLayout from 'layouts/main'
import trainingGroupsService, {
  TrainingGroup,
  UpdateTrainingGroupRequest,
} from 'services/http/dataset/training-group'

import { UpdateTrainingGroupProps } from './types'
import TrainingGroupForm from './TrainingGroupForm'

const UpdateTrainingGroup: React.FunctionComponent<UpdateTrainingGroupProps> =
  ({ match, history }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isReady, setIsReady] = useState(true)
    const [trainingGroup, setTrainingGroup] = useState<TrainingGroup>()
    const [flagcard] = useFlagcardContext()

    useEffect(() => {
      const id = parseInt(match.params.id)

      trainingGroupsService
        .getById(id)
        .then((res) => {
          setTrainingGroup(res.data)
        })
        .catch((err: Error) => {
          console.log(err)
        })
        .finally(() => {
          setIsReady(false)
        })
    }, [match.params.id, history])

    const handleSubmit = (data: UpdateTrainingGroupRequest) => {
      if (data) {
        setIsLoading(true)

        trainingGroupsService
          .update(data)
          .then(() => {
            flagcard.add({
              id: uid(),
              appearance: 'success',
              title: 'İşlem Başarılı',
              children:
                'Geçerli veri, sistem üzerinde başarıyla güncellenmiştir.',
            })
          })
          .catch((error) => {
            console.log(error)

            flagcard.add({
              id: uid(),
              appearance: 'error',
              title: 'Hata Oluştu',
              children:
                'Geçerli veri güncellenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
          .finally(() => {
            setIsLoading(false)
          })
      }
    }

    const handleError = (error?: ValidationError) => {
      console.log(error)
    }

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Eğitim grubu" href="/training-group" />
        <BreadcrumbItem text="Eğitim grubu güncelle" />
      </Breadcrumb>
    )

    return (
      <MainLayout isLoading={isReady}>
        <Container width="medium">
          <Page>
            <PageHeader
              // actions={<Button appearance="error">Delete user</Button>}
              breadcrumbs={breadcrumbs}
              bottomBar={
                <p>
                  Aşağıdaki bilgileri doldurarak geçerli eğitim grubu
                  güncelleyebilirsiniz.
                </p>
              }
            >
              Veri güncelleniyor: {trainingGroup ? trainingGroup.name : null}
            </PageHeader>
            <TrainingGroupForm
              actions={
                <ButtonGroup>
                  <Button
                    appearance="primary"
                    children="Güncelle"
                    isLoading={isLoading}
                    type="submit"
                  />
                  <LinkButton href="/training-group">İptal</LinkButton>
                </ButtonGroup>
              }
              operation="update"
              onSubmit={handleSubmit}
              onError={handleError}
              values={trainingGroup}
            />
          </Page>
        </Container>
      </MainLayout>
    )
  }

export default UpdateTrainingGroup
